import { render, staticRenderFns } from "./GridCategoryItem.vue?vue&type=template&id=598a82d6&scoped=true&"
import script from "./GridCategoryItem.vue?vue&type=script&lang=ts&"
export * from "./GridCategoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./GridCategoryItem.vue?vue&type=style&index=0&id=598a82d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598a82d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
